import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { retry, switchMap, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LegacyHealthCheckService } from '@coin/shared/core/data-access';

@Component({
  selector: 'coin-siemens-energy-no-backend-screen',
  templateUrl: './no-backend-screen.component.html',
  styleUrls: ['./no-backend-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoBackendScreenComponent implements OnInit {
  private healthCheckService = inject(LegacyHealthCheckService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  @Input() noPing = false;
  @Input() hideTimeInfo = false;

  private check: Subscription;

  ngOnInit(): void {
    this.setHealthcheck();
  }

  private setHealthcheck(): void {
    if (this.noPing) {
      return;
    }

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd && !event?.url?.includes('fallback')) {
        this.check.unsubscribe();
      }
    });

    this.check = interval(2000)
      .pipe(
        switchMap(() => this.healthCheckService.ping()),
        tap(() => {
          this.router.navigate(['']);
          this.check.unsubscribe();
        }),
        retry(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
